import { OmniaConfig } from "../config"
import { I18nService } from "../i18n/types"
import { IOmniaSession } from "../types"

export interface GlobalContext {
    readonly session: IOmniaSession
    readonly config: OmniaConfig
    readonly i18n: I18nService
}

let context: React.Context<GlobalContext>

export function setupGlobalContext(session: IOmniaSession, i18n: I18nService, config: OmniaConfig) {

    context = React.createContext({ session, config, i18n })

}

export function useOmniaContext() {

    return React.useContext(context)

}
